import { Component } from '@angular/core';


export class SkyPageSummaryKeyInfoComponent { static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-page-summary-key-info',
  template: `<div class="sky-page-summary-key-info">
  <ng-content></ng-content>
</div>
`,
  styles: [`@media (max-width: 767px) {
  .sky-page-summary-key-info {
    margin-top: 20px;
  }
}

.sky-page-summary-key-info /deep/ .sky-key-info {
  display: block;
}
`]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
